var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalnut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1008,
    height: 169,
    viewBox: "0 0 1008 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.3 168.68H114.71L61.68 60.12C59.323 55.2868 55.6556 51.2131 51.0958 48.363C46.536 45.5129 41.2672 44.0011 35.89 44H0.47998L53.48 152.58C55.842 157.414 59.5153 161.487 64.0807 164.333C68.6461 167.18 73.9198 168.686 79.3 168.68Z",
    fill: "#F33D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.73 73.48L249.96 44L214.96 43.83C209.537 43.8019 204.216 45.3104 199.615 48.181C195.014 51.0515 191.319 55.1667 188.96 60.05L174.62 89.76L209.93 89.7C215.319 89.6881 220.596 88.1609 225.158 85.2927C229.72 82.4246 233.384 78.3312 235.73 73.48Z",
    fill: "#F33D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.94 44.01L76.71 89.84H121.32",
    fill: "#B62E36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.76 168.68H213.17L160.17 60.12C157.811 55.2838 154.141 51.208 149.577 48.3577C145.014 45.5074 139.741 43.9974 134.36 44H98.94L151.94 152.57C154.301 157.406 157.973 161.481 162.539 164.329C167.104 167.178 172.379 168.685 177.76 168.68Z",
    fill: "#F33D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.97 47.46L444.65 166.11H424.05L389.8 76.11L355.1 166.11H334.48L290.4 47.46H310.78L345.25 141.93L381.07 47.46H399.2L434.35 142.38L469.72 47.46H488.97Z",
    fill: "#151C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.33 47.46V166.11H589.74V147.31C580.11 160.74 564.89 167.45 547.43 167.45C512.73 167.45 487.43 143.05 487.43 106.79C487.43 70.53 512.73 46.34 547.43 46.34C564.22 46.34 578.99 52.61 588.84 65.34V47.46H610.33ZM589.06 106.79C589.06 81.49 571.83 65.15 549.22 65.15C526.38 65.15 509.14 81.49 509.14 106.79C509.14 132.09 526.38 148.65 549.22 148.65C571.83 148.65 589.06 132.08 589.06 106.79Z",
    fill: "#151C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.13 0H654.62V166.11H633.13V0Z",
    fill: "#151C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.26 97.83V166.11H768.76V100.29C768.76 77.01 757.12 65.59 736.76 65.59C713.93 65.59 699.15 79.25 699.15 104.99V166.11H677.65V47.46H698.25V65.37C706.98 53.28 722.25 46.37 741 46.37C769.88 46.34 790.26 62.91 790.26 97.83Z",
    fill: "#151C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.25 47.46V166.11H897.87V148.2C889.14 160.51 874.37 167.45 857.58 167.45C826.91 167.45 806.58 150.66 806.58 115.74V47.46H828.07V113.28C828.07 136.56 839.71 148.2 860.07 148.2C882.46 148.2 896.78 134.32 896.78 108.8V47.46H918.25Z",
    fill: "#151C46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.98 159.17C1001.49 164.77 991.64 167.45 981.98 167.45C958.03 167.45 944.37 154.24 944.37 130.29V65.15H931.37V47.46H944.37V21.46H965.86V47.46H999.86V65.15H965.86V129.4C965.86 142.16 972.58 149.32 984.45 149.32C990.517 149.393 996.432 147.42 1001.24 143.72L1007.98 159.17Z",
    fill: "#151C46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1007.5,
    height: 168.68,
    fill: "white",
    transform: "translate(0.47998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalnut);
export default __webpack_public_path__ + "static/media/Walnut.4fc9370ddb2b696b67615e6cec60d8ff.svg";
export { ForwardRef as ReactComponent };